module.exports = __webpack_public_path__ + "img/offeo-4.e69bef68.png";